export default "__VITE_ASSET__Cvx1tkCo__"